import React, { useContext } from 'react';
import type { ICellRendererParams } from 'ag-grid-community';

import GridCellErrorBoundary from '../../../GridCellErrorBoundary';
import KingpinBadge from '../../../../kingpin/atoms/Badge';
import Cell from '../../../V5Gadget/Matrix/Cell';
import { BonusRecordTaggingContext } from './BonusRecordTaggingProvider';

export const BONUS_TAG_PILL_CELL = 'BONUS_TAG_PILL_CELL';

// Reads the tagged set from context (not the row's static data) so the pill
// updates reactively when a tag is saved/removed — without refetching (the
// backend reindex of `tags` is delayed) — mirroring how the select checkbox
// tracks selection.
const BonusTagPillCell = (params: ICellRendererParams) => {
  const { taggedDocumentIds, tagOption } = useContext(
    BonusRecordTaggingContext,
  );
  const id = params.data?.id;

  if (!id || !taggedDocumentIds.includes(id)) {
    return null;
  }

  return (
    <Cell>
      <div>
        <KingpinBadge badgeType={tagOption.color} text={tagOption.label} />
      </div>
    </Cell>
  );
};

const Gate = (params: ICellRendererParams) => (
  <GridCellErrorBoundary
    params={params}
    childComponent={<BonusTagPillCell {...params} />}
  />
);

export default Gate;
